import { tv } from 'tailwind-variants';

export const tailwindVariants = tv({
  slots: {
    backgroundBG: [
      'bg-components-accordion-color-bg',
      'py-themes-general-surface-spacing-small-padding-y',
      'px-spacing-padding-large-2',
      'md:px-themes-general-surface-spacing-large-padding-x',
      'md:py-themes-general-surface-spacing-large-padding-y',
    ],
    componentHeaderContentWrapper: [
      'flex',
      'flex-col',
      'flex-1',
      'md:mb-0',
      'gap-y-0',
      'md:gap-y-themes-general-surface-spacing-large-title-margin-bottom',
    ],
    componentTitle: [
      'font-header-small-small',
      'leading-header-small-small',
      'text-header-small-small',
      'text-components-accordion-color-title',
      'md:font-header-large-small',
      'md:leading-leading-header-large-small',
      'md:text-header-large-small',
    ],
    panel: [
      'hover:cursor-pointer',
      'bg-components-accordion-color-item-item-bg',
      'border-components-accordion-color-item-divider',
      'flex',
      'flex-col',
      'border-t-2',
      'border-b-2',
      'mb-components-accordion-spacing-small-item-item-space-between',
      'rounded-themes-radius-small-item',
      'last:mb-0',
      'md:mb-components-accordion-spacing-large-item-item-space-between',
      'md:px-components-accordion-spacing-large-item-padding-x',
      'md:rounded-components-accordion-spacing-large-item-item-radius',
    ],
    panelBody: [
      'panelBody',
      'hover:cursor-auto',
      'rtl:text-start',
      'py-components-accordion-spacing-small-item-padding-y',
      'md:py-components-content-list-list-item-container-padding-y',
      'md:px-components-content-list-list-item-container-padding-x',
      'border-y',
      'border-y-components-site-search-facet-stroke',
    ],
    panelHeader: [
      'md:flex',
      'md:items-center',
      'md:gap-x-themes-general-surface-spacing-large-body-margin-right',
      'mb-components-accordion-spacing-small-copy-margin-bottom',
      'md:mb-themes-general-surface-spacing-large-margin-bottom',
    ],
    panelBodyWrapper: [
      'panelBodyWrapper',
      'flex',
      'flex-col',
      'px-components-accordion-spacing-small-padding-x',
      'py-components-accordion-spacing-large-content-padding-y',
      'md:px-components-content-list-list-item-container-padding-x',
      'md:py-components-content-list-list-item-container-padding-y',

      'text-components-site-search-facet-group-label-text',
      'text-bodySans-medium',
      'font-bodySans-medium',
      'leading-bodySans-medium',
      '!cursor-auto',
    ],
    panelTitle: ['align-stretch', 'flex', 'flex-1', 'flex-col', 'justify-center'],
    ingredientTitle: [
      'ingredientTitle',
      'flex',
      'flex-row',
      'text-components-site-search-facet-group-label-text',
      'text-bodySans-large-semibold',
      'font-bodySans-large-semibold',
      'leading-bodySans-large-semibold',
      'w-fit',
    ],
    ingredientRole: [
      'ingredientRole',
      'text-components-accordion-color-item-title-item-default',
      'text-bodySans-xSmall-semibold',
      'font-bodySans-xSmall-semibold',
      'leading-bodySans-xSmall-semibold',
    ],
    ingredientDescription: [
      'py-components-content-list-list-item-content-default-padding-y',
      'text-components-site-search-facet-group-label-text',
      'text-bodySans-xSmall',
      'font-bodySans-xSmall',
      'leading-bodySans-xSmall',
    ],
    fragranceDescription: [
      'flex',
      'flex-row',
      '!flex-wrap',
      'py-components-content-list-list-item-content-default-padding-y',
      'text-components-site-search-facet-group-label-text',
    ],
    ingredientDisclaimer: [
      '!mt-spacing-spacing-3',
      'text-components-site-search-facet-group-label-text',
      'text-bodySans-xSmall',
      'font-bodySans-xSmall',
      'leading-bodySans-xSmall',
    ],
    panelWrapperReg: ['flex', 'flex-col', 'gap-y-[18px]'],
    panelTitleButton: [
      'flex',
      'flex-row',
      'font-bodySans-large-semibold',
      'leading-bodySans-large-semibold',
      'text-bodySans-large-semibold',
      'text-components-accordion-color-item-title-item-default',
      'py-components-accordion-spacing-small-item-padding-y',
      'md:py-components-accordion-spacing-large-item-padding-y',
      'text-left',
      'rtl:text-start',
      'w-full',
    ],
    panelTitleIcon: [
      'fill-components-accordion-color-item-icon-icon-default',
      'ml-auto',
      '[&_svg]:h-[32px]',
      '[&_svg]:w-[32px]',
    ],
    panelTitleText: [
      'w-full',
      'flex',
      'flex-row',
      'font-bodySans-large-semibold',
      'text-bodySans-large-semibold',
      'leading-bodySans-large-semibold',
      'text-components-accordion-color-item-title-item-default',
    ],
    panelRoleText: [
      'font-bodySans-medium',
      'text-bodySans-medium',
      'leading-bodySans-medium',
      'text-components-accordion-color-content-body',
      'w-full',
    ],
    panelWrapper: ['flex', 'flex-col'],
    ingredientWrapper: [
      'flex',
      'flex-col',
      'py-components-content-list-list-item-content-default-padding-y',
      'gap-components-content-list-list-item-content-space-between',
    ],
    registeredProductRTE: [
      'text-components-site-search-facet-group-label-text',
      'text-bodySans-medium',
      'font-bodySans-medium',
      'leading-bodySans-medium',
      'px-themes-general-surface-spacing-small-padding-x',
      'py-themes-general-surface-spacing-small-padding-y',
      'md:px-themes-general-surface-spacing-large-padding-x',
      'md:py-spacing-spacing-6',
    ],
  },
  variants: {
    alignment: {
      left: {
        panelBody: ['text-left'],
        panelTitle: ['flex-row'],
        panelTitleButton: ['flex-row', 'text-left'],
      },
      right: {
        panelBody: ['text-right'],
        panelTitle: ['flex-row-reverse'],
        panelTitleButton: ['flex-row-reverse', 'text-right'],
      },
    },
    isOpen: {
      false: {
        panelBodyWrapper: ['hidden'],
      },
      true: {
        panelBodyWrapper: ['block'],
      },
    },
    isRegistered: {
      false: {
        panelTitleButton: ['!cursor-pointer'],
        panelBodyWrapper: [
          'isRegistered-false',
          'md:px-components-content-list-list-item-container-padding-x',
          'md:py-components-content-list-list-item-container-padding-y',

          '!text-components-site-search-facet-group-label-text',
          '!text-bodySans-medium',
          '!font-bodySans-medium',
          '!leading-bodySans-medium',
          '!cursor-auto',
          '!ml-0',
          '!flex-col',
        ],
        ingredientDisclaimer: ['md:!py-components-content-list-list-item-container-padding-y'],
      },
      true: {
        panelTitleButton: ['!cursor-auto'],
        panelBody: [
          'isRegistered-true',
          'px-components-content-list-list-item-container-padding-x',
          'py-components-content-list-list-item-container-padding-y',
        ],
        fragranceDescription: [
          '!text-bodySans-xSmall',
          '!font-bodySans-xSmall',
          '!leading-bodySans-xSmall',
        ],
        panelBodyWrapper: [
          'px-components-accordion-spacing-small-padding-x',
          '!px-components-content-list-list-item-container-padding-x',
          '!py-components-content-list-list-item-container-padding-y',
          'md:!px-0',
          'md:!py-components-accordion-spacing-large-content-padding-y',
          'gap-0',
        ],
      },
    },
    isFragrance: {
      true: {
        panelBodyWrapper: ['flex', '!flex-row', 'flex-wrap', '-ml-2'],
      },
      false: {},
    },
  },
});
